module.exports = __webpack_public_path__ + "img/china-sinopec-bg-icon.71c94568.png";